import { Save } from '@mui/icons-material';
import { IconButton, IconButtonProps, InputAdornment } from '@mui/material';
import { useTranslation } from 'next-i18next';
import VyTextField, { VyTextFieldProps } from '../../common/VyTextField';
import VyTooltip from '../../common/VyTooltip';
import { VYSTEMBLUE } from '../../../static/constants';

interface InlineEditTextFieldInterface extends VyTextFieldProps {
  saveButtonProps: IconButtonProps;
}
const InlineEditTextField = ({ saveButtonProps, ...textfieldProps }: InlineEditTextFieldInterface) => {
  const { t } = useTranslation();

  return (
    <VyTextField
      {...textfieldProps}
      InputProps={{
        endAdornment: !saveButtonProps.hidden && (
          <InputAdornment position="end">
            <VyTooltip title={t('pagebuilder:save-changes')}>
              <IconButton className="animate-pulse" edge="end" style={{ color: VYSTEMBLUE }} {...saveButtonProps}>
                <Save />
              </IconButton>
            </VyTooltip>
          </InputAdornment>
        ),
      }}
    />
  );
};
export default InlineEditTextField;
